/*Date.prototype.toJSON = function(){
	this.setHours(this.getHours() - this.getTimezoneOffset() / 60);
    return this.toISOString();
};*/
window.RandExp = require("randexp");
window.swal = require("sweetalert2");
window._ = require("lodash");
require("vue-js-modal");
require("vue-select");
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
var Prism = require("prismjs");
var Normalizer = require("prismjs/plugins/normalize-whitespace/prism-normalize-whitespace");
var nw = new Normalizer({
  "remove-trailing": true,
  "remove-indent": true,
  "left-trim": true,
  "right-trim": true,
});
window.money = {
  numeral: true,
  numeralDecimalScale: 2,
  numeralPositiveOnly: true,
  prefix: "$ ",
  rawValueTrimPrefix: true,
};
window.money2 = {
  numeral: true,
  numeralDecimalScale: 2,
  numeralPositiveOnly: false,
  prefix: "$ ",
  rawValueTrimPrefix: true,
};
window.money3 = {
  numeral: true,
  numeralDecimalScale: 5,
  numeralPositiveOnly: true,
  prefix: "$ ",
  rawValueTrimPrefix: true,
};
window.decimal = {
  numeral: true,
  numeralDecimalScale: 5,
  numeralPositiveOnly: true,
};
window.decimal2 = {
  numeral: true,
  numeralDecimalScale: 3,
  numeralPositiveOnly: true,
};
window.decimal3 = {
  numeral: true,
  numeralDecimalScale: 2,
};
window.decimal4 = {
  numeral: true,
  numeralDecimalScale: 5,
};
window.porcentaje = {
  numeral: true,
  numeralDecimalScale: 5,
  numeralPositiveOnly: true,
  prefix: "% ",
  rawValueTrimPrefix: true,
};
window.int = {
  numeral: true,
  numeralDecimalScale: 0,
  numeralPositiveOnly: true,
};
window.numero = {
  numeral: true,
  numeralDecimalScale: 0,
  numeralPositiveOnly: true,
  numeralThousandsGroupStyle: "none",
  stripLeadingZeroes: false,
};
window.locale = "en-US";
window.uuid = require("uuid/v1");

window.moment = require("moment");

window.copy = function(id) {
  let datos = document.getElementById(id);
  datos.select();
  document.setExcelCommand("copy");
  document.execCommand("copy");
};
window.round = function (value, precision) {
	var multiplier = 0;
	for(let i=6;i>=precision; i--){
	  multiplier = Math.pow(10, i || 0);
	  value = Math.round(value * multiplier) / multiplier;
	}    
	return value;
  }

window.format = require("format-number");
window.moneyFormat = window.format({
  prefix: "$",
  decimalSeparator: ".",
  integerSeparator: ",",
  round: 2,
  padRight: 2,
});



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js